interface OrganizationMockupProps {
    name?: string;
    street?: string;
    postalCode?: string;
    city?: string;
}

export const OrganizationMockup = ({ name, street, postalCode, city }: OrganizationMockupProps) => {
    const displayName = name || "Ihr Laborname";
    const displayStreet = street || "Musterstrasse 123";
    const displayLocation = postalCode && city ? `${postalCode} ${city}` : "8000 Zürich";

    return (
        <div className="relative">
            {/* Main document */}
            <div className="bg-white rounded-lg shadow-xl w-[340px] h-[440px] p-8 relative">
                {/* Header with lab info */}
                <div className="border-b-2 border-gray-100 pb-6 mb-6">
                    <div
                        className="text-lg font-semibold text-gray-800 truncate"
                        style={{ maxWidth: '280px' }}
                    >
                        {displayName}
                    </div>
                    <div className="text-sm text-gray-500 mt-1">{displayStreet}</div>
                    <div className="text-sm text-gray-500">{displayLocation}</div>
                </div>
                {/* Abstract document content */}
                <div className="space-y-4">
                    <div className="flex justify-between items-center">
                        <div className="h-3 w-24 bg-gray-200 rounded" />
                        <div className="h-3 w-32 bg-gray-100 rounded" />
                    </div>
                    <div className="h-3 w-full bg-gray-100 rounded" />
                    <div className="h-3 w-4/5 bg-gray-100 rounded" />
                    <div className="h-6" />
                    <div className="h-3 w-20 bg-gray-300 rounded" />
                    <div className="border border-gray-200 rounded p-3 space-y-2">
                        <div className="flex justify-between">
                            <div className="h-2.5 w-32 bg-gray-100 rounded" />
                            <div className="h-2.5 w-16 bg-gray-200 rounded" />
                        </div>
                        <div className="flex justify-between">
                            <div className="h-2.5 w-28 bg-gray-100 rounded" />
                            <div className="h-2.5 w-16 bg-gray-200 rounded" />
                        </div>
                        <div className="flex justify-between">
                            <div className="h-2.5 w-36 bg-gray-100 rounded" />
                            <div className="h-2.5 w-16 bg-gray-200 rounded" />
                        </div>
                        <div className="border-t border-gray-200 pt-2 flex justify-between">
                            <div className="h-3 w-16 bg-gray-300 rounded" />
                            <div className="h-3 w-20 bg-[#8db599] rounded" />
                        </div>
                    </div>
                    <div className="h-8" />
                    <div className="h-3 w-full bg-gray-100 rounded" />
                    <div className="h-3 w-3/4 bg-gray-100 rounded" />
                </div>
            </div>
        </div>
    );
};